module.exports = __webpack_public_path__ + "img/sld_scb_33_t1_b1_green.ce7a8567.svg";